import "./style.scss";

import { useCallback, useEffect, useRef, useState } from "react";

import File from "components/File";
import HeaderSection from "components/HeaderSection";
import { ReactComponent as IconLeft } from "assets/img/icons/icon_arrow-Left.svg";
import { ReactComponent as IconRight } from "assets/img/icons/icon_arrow-Right.svg";
import { formattedStringToDate } from "utils/utils";

const DocsPerOrganisms = ({ organisms, offreId=0, status }: { organisms: any, offreId: any, status: any }) => {
    const [isScrollableLeft, setIsScrollableLeft] = useState<boolean>(false);
    const [isScrollableRight, setIsScrollableRight] = useState<boolean>(true);

    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const checkScrollButtons = useCallback(() => {
        const container = scrollContainerRef.current;
        if (container) {
            const maxScrollLeft = container.scrollWidth - container.clientWidth;
            setIsScrollableLeft(container.scrollLeft > 0);
            setIsScrollableRight(container.scrollLeft < maxScrollLeft || container.scrollLeft === maxScrollLeft - 0.5);
        }
    }, []);

    const scrollLeft = useCallback(() => {
        if (scrollContainerRef.current) {
            (scrollContainerRef.current as HTMLElement).scrollBy({ top: 0, left: -300, behavior: "smooth" });
        }
    }, []);

    const scrollRight = useCallback(() => {
        if (scrollContainerRef.current) {
            (scrollContainerRef.current as HTMLElement).scrollBy({ top: 0, left: 300, behavior: "smooth" });
        }
    }, []);

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (container) {
            container.addEventListener("scroll", checkScrollButtons);

            // Vérification initiale pour les boutons de défilement
            checkScrollButtons();
        }

        return () => {
            if (container) {
                container.removeEventListener("scroll", checkScrollButtons);
            }
        };
    }, []);

    return (
        <>
            <HeaderSection
                title={`${offreId === 6 ? 'Courriers non envoyés' : 'Organismes contactés'}`}
                // number="5/5"
            />
            <div
                className="DocsPerOrganisms"
                ref={scrollContainerRef}>
                <div className="DocsPerOrganisms__list scroll-container">
                    {organisms?.map((organism: any, index: number) => (
                        <div
                            className="DocsPerOrganisms__organism"
                            key={index}>
                            <div className="DocsPerOrganisms__organism__header">
                                <div className="DocsPerOrganisms__organism__header__img">
                                    {/* <img
                                        src={organism.logoPath}
                                        alt={organism.name}
                                    /> */}
                                </div>
                                <h4 className="DocsPerOrganisms__organism__header__title">{organism.name}</h4>
                            </div>
                            <div className="DocsPerOrganisms__organism__documents">


                                {((organism.declaration && offreId !== 6 && status !== 'Traitement du dossier') ||
                                  (organism.declaration && offreId === 6)) && (
                                  <File
                                    file={{
                                        name: organism.declarationName ? organism.declarationName : "Déclaration",
                                        path: organism.declaration,
                                        status: !organism.declaration ? "En attente" : "Envoyé",
                                    }}
                                  />
                                )}
                                {!organism.declaration && (
                                  <div className="card">
                                      Déclaration <br/> en-cours
                                  </div>
                                )}

                                {organism.accuse && (
                                    <File
                                        file={{
                                            name: organism.accuseName ? organism.accuseName : "Accusé de réception",
                                            path: organism.accuse,
                                            status: !organism.accuse ? "En attente" : "Reçu",
                                        }}
                                    />
                                )}
                                {!organism.accuse && (
                                    <div className="card">
                                        Accusé <br/> en-cours
                                    </div>
                                )}
                            </div>
                            {organism?.dateReceptionAR != "" && organism?.dateReceptionAR && (
                                <div className="text-center">
                                    Reçu le : {formattedStringToDate(organism.dateReceptionAR)}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
            <div className="scroll-buttons">
                <IconLeft
                    onClick={scrollLeft}
                    fill={isScrollableLeft ? "#1956A8" : "#9FC1EF"}
                    className="pointer"
                />
                <IconRight
                    onClick={scrollRight}
                    fill={isScrollableRight ? "#1956A8" : "#9FC1EF"}
                    className="pointer"
                />
            </div>
        </>
    );
};

export default DocsPerOrganisms;
